import { useSearchParams } from "react-router-dom";

export interface SetValue<R = string> {
  (value: R): void;
}

export default function useUrlState<R = string>(
  key: string,
  defaultValue?: R,
  replace: boolean = false
): [R | undefined, SetValue<R>] {
  const [searchParams, setSearchParams] = useSearchParams();

  const setValue = (value?: R) => {
    const newSearchParams = new URLSearchParams(window.location.search);
    setSearchParams(
      () => {
        if (value) {
          newSearchParams.set(key, String(value));
        } else {
          newSearchParams.delete(key);
        }
        return newSearchParams;
      },
      { replace: replace }
    );
  };

  const value = (searchParams.get(key) as R) || defaultValue;

  return [value, setValue];
}
